import { FETCH_LAST_VER,FETCH_LAST_VER_REFRESH, FETCH_RESULT, FETCH_VER } from '../actions/types'



const lastverReducer = (state = 0, action) => {
  switch (action.type) {
    case FETCH_LAST_VER:
      return action.lastver
    case FETCH_RESULT:
      return action.ver
    case FETCH_LAST_VER_REFRESH:
      return action.ver
    default:
      return state
  }
}

export default lastverReducer